import type { VideoStatus } from 'models';
import { useCallback } from 'react';
import { ArchiveLineIcon, Document3LineIcon, type TagProperties, VideoLineIcon } from 'ui';

export const useGetVideoStatusTagProperties = () =>
  useCallback(({ status }: { status: VideoStatus }): TagProperties => {
    switch (status) {
      case 'archived':
        return { bordered: true, children: 'Video (Archived)', icon: <ArchiveLineIcon /> };
      case 'draft':
        return { bordered: true, children: 'Video (Draft)', icon: <Document3LineIcon /> };
      case 'published':
        return { children: 'Video', color: 'purple', icon: <VideoLineIcon /> };
    }
  }, []);
